export type SortOrderType = 'SORT_ORDER_UNKNOWN' | 'ASC' | 'DESC';

export enum SortOrder {
  SORT_ORDER_UNKNOWN = 'SORT_ORDER_UNKNOWN',
  ASC = 'ASC',
  DESC = 'DESC',
}
